"use client";

import { Landmark, Building2, Vote, User, TrendingUp, Shield } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { whoItsFor as data } from "@/lib/data/capabilities-narrative-engineering";

const iconMap: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = {
  Landmark, Building2, Vote, User, TrendingUp, Shield,
};

const accentMap: Record<string, string> = {
  "Government and Sovereign Entities": "var(--color-crimson)",
  "Global Enterprises and Fortune 500": "var(--color-denim)",
  "Political Organizations and Campaigns": "var(--color-violet)",
  "Public Figures and HNWIs": "var(--color-amber)",
  "Financial Institutions and Healthcare": "var(--color-emerald)",
  "Defense and Strategic Organizations": "var(--color-purple)",
};

export function WhoItsFor() {
  return (
    <Section id="who-its-for" className="relative">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute bottom-1/4 left-1/4 h-80 w-80 rounded-full bg-[var(--color-denim)] opacity-15 blur-[120px]" />
      </div>

      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-denim)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.segments.map((s) => {
            const Icon = iconMap[s.icon] ?? Building2;
            const accent = accentMap[s.title] ?? "var(--color-crimson)";
            return (
              <Reveal key={s.title} delay={60}>
                <div
                  className="glass rounded-2xl p-6 h-full"
                  style={{
                    boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)`,
                  }}
                >
                  <span
                    className="grid place-items-center h-11 w-11 rounded-xl"
                    style={{
                      background: `color-mix(in oklch, ${accent} 18%, transparent)`,
                      boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)`,
                    }}
                  >
                    <Icon className="h-5 w-5" style={{ color: accent }} />
                  </span>
                  <h3 className="mt-4 text-lg">{s.title}</h3>
                  <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}
